import { createApi } from '@reduxjs/toolkit/query/react';
import { FeedbackResponse } from 'src/types/models/FeedbackResponse';
import { feedbackQuery } from './config';
import { EditorFeedback } from 'src/types/feedback/models/EditorFeedback';

export const feedbackApi = createApi({
  reducerPath: 'feedbackApi',
  baseQuery: feedbackQuery,
  endpoints: (build) => ({
    createEditorFeedback: build.mutation<
      FeedbackResponse,
      { user_id: string; data: EditorFeedback }
    >({
      query: ({ user_id, data }) => ({
        url: `/users/${user_id}/feedback`,
        method: 'POST',
        body: {
          data,
        },
      }),
    }),
  }),
});

export const { useCreateEditorFeedbackMutation } = feedbackApi;
